import type { BookingConflict } from "../../api/types";

export type CalendarMode = "day" | "week" | "month" | "agenda" | "portfolio";

export interface CalendarFilters {
  locationId: string;
  status: string;
  approval: string;
  source: string;
  ownerId: string;
  customer: string;
  payment: string;
  attention: string;
}

export const emptyCalendarFilters: CalendarFilters = {
  locationId: "",
  status: "",
  approval: "",
  source: "",
  ownerId: "",
  customer: "",
  payment: "",
  attention: "",
};

export interface CalendarEntry {
  occurrenceId: string;
  // Which side of the workspace this row came from. The calendar shows both, because a room is
  // occupied whoever is in it, but a hire and one of the client's own events open in different
  // places and only this says which.
  kind: "booking" | "event";
  eventId?: string;
  bookingId: string;
  reference: string;
  title: string;
  customerId: string;
  customerName: string;
  ownerId?: string;
  ownerName: string;
  status: string;
  approvalState: string;
  source: string;
  start: string;
  end: string;
  timezone: string;
  version: number;
  venueIds: string[];
  venueNames: string[];
  locationIds: string[];
  locationNames: string[];
  conflictOverridden: boolean;
  paymentState: string;
  openTaskCount: number;
  overdueTaskCount: number;
  hasInventory: boolean;
  hasSponsor: boolean;
}

export interface CalendarResponse {
  items: CalendarEntry[];
  from: string;
  to: string;
}

export interface CalendarViewDefinition {
  mode: CalendarMode;
  filters: CalendarFilters;
}

export interface CalendarView {
  id: string;
  name: string;
  definition: CalendarViewDefinition;
  visibility: "private" | "tenant";
  isDefault: boolean;
  version: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CalendarViewList {
  items: CalendarView[];
}

export interface RescheduleOccurrence {
  id: string;
  start: string;
  end: string;
  setupMinutes: number;
  teardownMinutes: number;
}

export interface RescheduleProposal {
  id: string;
  bookingId: string;
  baseVersion: number;
  scope: "single_occurrence" | "following" | "series" | "booking";
  state: {
    occurrences: RescheduleOccurrence[];
    locationIds: string[];
    confirmConflictOverride: boolean;
    conflictOverrideReason: string;
  };
  conflicts: BookingConflict[];
  reason: string;
  status: string;
  canOverride: boolean;
  createdAt: string;
  appliedAt?: string;
}
